<aside class="main-sidebar">
    <section class="sidebar">
        <ul class="sidebar-menu nav-listing">
            <li *ngFor="let menuItem of visibleMenuItems">
                <a href="" 
                   [class]="menuItem.cssClass" 
                   [class.active]="isActive(menuItem.route)" 
                   [routerLink]="menuItem.route" 
                   [appTooltip]="menuItem.tooltip">
                    <i *ngIf="menuItem.icon" [class]="menuItem.icon"></i>
                    <i *ngIf="!menuItem.icon"></i>
                    <span>{{ menuItem.label }}</span>
                </a>
            </li>
        </ul>
    </section>
</aside>
